import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const SakuraTree3D = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Dynamically import model-viewer
    import('@google/model-viewer').catch(console.error);
  }, []);

  // Generate falling petals
  const petals = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    startX: 60 + Math.random() * 35,
    delay: Math.random() * 6,
    duration: 5 + Math.random() * 4,
    size: 6 + Math.random() * 10,
  }));

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* 3D Sakura Tree */}
      <motion.div
        ref={containerRef}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.5, delay: 0.5, ease: 'easeOut' }}
        className="absolute pointer-events-none"
        style={{ width: '1400px', height: '1600px', bottom: '-42%', right: '-350px' }}
      >
        <model-viewer
          src="/models/sakura_tree.glb"
          alt="Sakura Tree"
          auto-rotate
          rotation-per-second="3deg"
          camera-controls={false}
          disable-zoom
          disable-pan
          disable-tap
          interaction-prompt="none"
          shadow-intensity="0"
          exposure="1.0"
          style={{
            width: '100%',
            height: '100%',
            background: 'transparent',
            '--poster-color': 'transparent',
            opacity: 0.4,
          }}
          camera-orbit="-30deg 55deg 2.2m"
        />
      </motion.div>
      
      {/* Falling petals from the tree */}
      {petals.map((petal) => (
        <motion.div
          key={petal.id}
          className="absolute"
          style={{
            right: `${100 - petal.startX}%`,
            top: '15%',
            width: petal.size,
            height: petal.size,
          }}
          initial={{ y: 0, x: 0, rotate: 0, opacity: 0 }}
          animate={{
            y: ['0%', '75vh'],
            x: [0, Math.sin(petal.id) * 60, Math.sin(petal.id) * -30, Math.sin(petal.id) * 45],
            rotate: [0, 360, 720],
            opacity: [0, 0.9, 0.7, 0],
          }}
          transition={{
            duration: petal.duration,
            delay: petal.delay,
            repeat: Infinity,
            ease: 'linear',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" className="w-full h-full">
            <path
              d="M12 2C12 2 8 6 8 10C8 14 12 16 12 16C12 16 16 14 16 10C16 6 12 2 12 2Z"
              fill="#FFB7C5"
              opacity="0.9"
            />
          </svg>
        </motion.div>
      ))}
      
      {/* Ambient glow effect */}
      <motion.div
        className="absolute right-20 bottom-40 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full"
        animate={{
          opacity: [0.3, 0.5, 0.3],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  );
};

export default SakuraTree3D;
